import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AuthRedirectProps {
  children: React.ReactNode;
}

const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || loading) return;
    // Anyone who hasn't finished onboarding gets sent to the wizard first
    // (except clients, who have their own portal setup flow).
    if (user.onboardingStatus === 'PENDING' && user.role !== 'CLIENT') {
      navigate('/onboarding');
      return;
    }
    if (user.role === 'CLIENT') {
      navigate('/client/dashboard');
    } else {
      navigate('/dashboard/');
    }
  }, [user, loading, navigate]);

  // Show loading or landing page for unauthenticated users
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  // If user is authenticated, don't render children (will redirect)
  if (user) {
    return null;
  }

  // Render landing page for unauthenticated users
  return <>{children}</>;
};

export default AuthRedirect;
